// extracted by mini-css-extract-plugin
module.exports = {"icon_container":"Icon_icon_container__QqDJX","icon_container__icon":"Icon_icon_container__icon__1erIW","icon_container__icon__dark":"Icon_icon_container__icon__dark__2iNeI"};